import React from 'react';
import { Link } from 'react-router-dom';
import { HOME_PATH } from '../../constants/routes';
import { getPlatformLogoSrc } from '../../constants/branding';

export function AuthHeader() {
  const basename = process.env.PUBLIC_URL || '';

  return (
    <header className="auth-header">
      <div className="auth-header__inner">
        <Link
          to={HOME_PATH}
          className="auth-header__logo"
          aria-label="Go to home page"
          title="Go to home page"
        >
          <img src={getPlatformLogoSrc('big', basename)} alt="Traxccel Logo" />
        </Link>
        <div className="auth-header__separator" aria-hidden="true" />
        <Link
          to={HOME_PATH}
          className="auth-header__brand"
          aria-label="Go to home page"
          title="Go to home page"
        >
          <span className="auth-header__brand-re">Re</span>
          <span className="auth-header__brand-imagine">Imagine</span>
          <span className="auth-header__brand-version">2.0</span>
        </Link>
      </div>
    </header>
  );
}

export default AuthHeader;
